import type { LabelSuggestion } from '@atlassian/jira-issue-shared-types/src/common/types/labels-type.tsx';
import { type Action, createHook, createStore } from '@atlassian/react-sweet-state';

type StoreType = {
	defaultSuggestions: LabelSuggestion[] | null;
	defaultSuggestionsIssueId: string | null;
};

const actions = {
	setDefaultSuggestions:
		(defaultSuggestions: LabelSuggestion[]): Action<StoreType> =>
		({ setState }) => {
			setState({ defaultSuggestions });
		},
	addDefaultSuggestion:
		(label: string): Action<StoreType> =>
		({ setState, getState }) => {
			const defaultSuggestions = getState().defaultSuggestions
				? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					[...(getState().defaultSuggestions as LabelSuggestion[])]
				: [];
			const idx = defaultSuggestions.findIndex((suggestion) => suggestion.label === label);
			if (idx >= 0) {
				defaultSuggestions.splice(idx, 1);
			}
			setState({
				defaultSuggestions: [{ label, value: label }, ...defaultSuggestions].slice(0, 20),
			});
		},
	setDefaultSuggestionsIssueId:
		(issueId: string): Action<StoreType> =>
		({ setState, getState }) => {
			if (!getState().defaultSuggestionsIssueId) {
				setState({ defaultSuggestionsIssueId: issueId });
			}
		},
};

type Actions = typeof actions;

const LabelsStore = createStore<StoreType, Actions>({
	initialState: {
		defaultSuggestions: null,
		defaultSuggestionsIssueId: null,
	},
	actions,
	name: 'JWMLabels',
});

export const useLabelsStoreHook = createHook(LabelsStore);

export const useLabelsStore = (issueId: string) => {
	const labelsStore = useLabelsStoreHook();
	const [, { setDefaultSuggestionsIssueId }] = labelsStore;
	setDefaultSuggestionsIssueId(issueId);
	return labelsStore;
};
